export default __webpack_public_path__ + "static/media/iconLixeiraListagem.7f1feafc.svg";